/* GASSISA
=========================================================================================
* Descripción: Módulo de toma de inventarios - Encabezado
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 5/01/2026 | Lic. José Luis Aragón Cervantes  | Creación
* ---------------------------------------------------------------------------------------
*/

import { Dialog, DialogContent, DialogTitle, List, ListItem, ListItemText, Chip, Box } from "@mui/material";

export default function ZonasDiferenciasModal({ open, diffs, onClose }) {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>Zonas con diferencias (Conteo 1 vs Conteo 2)</DialogTitle>
      <DialogContent>
        <List dense sx={{ maxHeight: 520, overflow: "auto" }}>
          {(diffs || []).map((z) => (
            <ListItem key={z.Zona} divider>
              <ListItemText
                primary={
                  <Box display="flex" alignItems="center" gap={1}>
                    <b>{z.Zona}</b>
                    {z.Diferentes ? (
                      <Chip size="small" label="DIF" color="warning" />
                    ) : (
                      <Chip size="small" label="OK" color="success" />
                    )}
                  </Box>
                }
                secondary={`C1: ${z.TotalItemsConteo1} | C2: ${z.TotalItemsConteo2} — ${z.Motivo}`}
              />
            </ListItem>
          ))}
        </List>
      </DialogContent>
    </Dialog>
  );
}
